import delegateStatePage from '@/pages/delegate-management/delegate-state';
import delegateRecordPage from '@/pages/delegate-management/delegate-record';

//店长值班状态
export const delegateState = {
  path: 'delegate/delegateState',
  component: delegateStatePage
}

//值班记录报表
export const delegateRecord = {
  path: 'delegate/delegateRecord',
  component: delegateRecordPage
}


// WEBPACK FOOTER //
// ./src/router/delegate-management.js